import React from "react";
import {Image} from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import Media from 'react-media';

import "./IndustryNews.css";
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';


import icon_industry_news from "../../asset/images/icon_industry_news.webp";
import img_industry_1 from "../../asset/images/img_industry_1.png";
import img_industry_2 from "../../asset/images/img_industry_2.png";
import img_industry_3 from "../../asset/images/img_industry_3.png";
import img_industry_4 from "../../asset/images/img_industry_4.png";
import img_industry_5 from "../../asset/images/img_industry_5.png";
import img_industry_6 from "../../asset/images/img_industry_6.png";

SwiperCore.use([Autoplay, Pagination]);

// 行业新闻
class IndustryNews extends React.Component {
  render() {
    return (
      <div className="industry" id="industry">
        <Image src={icon_industry_news} className="industry_ico" />
        <div className="industry_swiper">
        <Media query="(max-width: 900px)" render={() =>
          (
            <Swiper
              slidesPerView={1}
              // slidesPerGroup={3}
              autoplay={{
                delay: "3000"
              }}
              loop={true}
              pagination={{ clickable: true }}
              onSwiper={
                (swiper)=>{
                  //鼠标悬浮暂停效果
                  swiper.$el[0].addEventListener('mouseover',()=>swiper.autoplay.stop());
                  //鼠标移开后继续自动滚屏效果
                  swiper.$el[0].addEventListener('mouseleave',()=>swiper.autoplay.start());
                }
              }
            >
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_1} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">节能减排势在必行</div>
                    <div className="industry_card_content">
                      李克强指出，我国是世界上最大的发展中国家，发展不平衡不充分问题仍很突出...
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_2} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">上海交通大学|产学研合作</div>
                    <div className="industry_card_content">
                      近日，北京涵智博雅能源科技有限公司总经理黄晓东、技术总监江明旒等人来到了上海交通大学......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2019-6-18</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_3} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">为时代做点事？</div>
                    <div className="industry_card_content">
                      人类赖以生存、生产的生态环境在现阶段虽然还面临着许多问题，而且部分问题目前难以克服和解决......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2019-5-19</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_4} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">进气阀科普篇</div>
                    <div className="industry_card_content">
                      螺杆式空压机的进气阀是空压机的呼吸口，普通空气进入进气阀后到压缩机头，经过压缩而产生压缩气体......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_5} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">解析大数据</div>
                    <div className="industry_card_content">
                      在人类社会的早期，民以食为天，数据的产生大多与商品，食物，土地等挂钩。旧石器时代......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_6} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">物联网与大数据息息相关？</div>
                    <div className="industry_card_content">
                      针对物联网的分析研究，其主要涵盖感知层、网络层还有应用层。感知层包含识读器、二维码标签、传感器......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          )}
        />
        <Media query="(min-width: 900px)" render={() =>
          (
            <Swiper
              slidesPerView={3}
              slidesPerGroup={3}
              autoplay={{
                delay: "3000"
              }}
              loop={true}
              pagination={{ clickable: true }}
              onSwiper={
                (swiper)=>{
                  //鼠标悬浮暂停效果
                  swiper.$el[0].addEventListener('mouseover',()=>swiper.autoplay.stop());
                  //鼠标移开后继续自动滚屏效果
                  swiper.$el[0].addEventListener('mouseleave',()=>swiper.autoplay.start());
                }
              }
            >
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_1} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">节能减排势在必行</div>
                    <div className="industry_card_content">
                      李克强指出，我国是世界上最大的发展中国家，发展不平衡不充分问题仍很突出...
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_2} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">上海交通大学|产学研合作</div>
                    <div className="industry_card_content">
                      近日，北京涵智博雅能源科技有限公司总经理黄晓东、技术总监江明旒等人来到了上海交通大学......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2019-6-18</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_3} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">为时代做点事？</div>
                    <div className="industry_card_content">
                      人类赖以生存、生产的生态环境在现阶段虽然还面临着许多问题，而且部分问题目前难以克服和解决......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2019-5-19</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_4} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">进气阀科普篇</div>
                    <div className="industry_card_content">
                      螺杆式空压机的进气阀是空压机的呼吸口，普通空气进入进气阀后到压缩机头，经过压缩而产生压缩气体......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_5} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">解析大数据</div>
                    <div className="industry_card_content">
                      在人类社会的早期，民以食为天，数据的产生大多与商品，食物，土地等挂钩。旧石器时代......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industry_card">
                  <Image src={img_industry_6} className="industry_card_img" />
                  <div className="industry_card_word">
                    <div className="industry_card_title">物联网与大数据息息相关？</div>
                    <div className="industry_card_content">
                      针对物联网的分析研究，其主要涵盖感知层、网络层还有应用层。感知层包含识读器、二维码标签、传感器......
                    </div>
                    <div className="industry_card_footer">
                      <div className="industry_card_more">了解更多</div>
                      <div className="industry_card_date">2020-7-28</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          )}
        />
          
        </div>
      </div>
    )
  }
}

export default IndustryNews
